<template>
  <div class="emap-flow-modal-changeAssignee">
    <Modal v-model="groupVisible" :title="$LocalH5('selectMember')" :mask-closable="false" v-if="options.groups && users.length || isMultiInstance">
      <div class="container">
        <div class="ivu-form-item" v-if="isMultiInstance">
          <label class="label">{{$LocalH5('toolbar.toUserGroup')}}</label>
          <div class="ivu-form-item-content" style="margin-left: 100px;">
            <Select v-model="group" clearable>
              <Option v-for="(item, index) in groups" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </div>
        </div>
        <div class="ivu-form-item" v-else>
          <label class="label">{{$LocalH5('toolbar.toPersonnel')}}</label>
          <div class="ivu-form-item-content" style="margin-left: 100px;">
            <Select v-model="user" clearable>
              <Option v-for="(item, index) in users" :value="item.userId" :key="index">{{ item.userName }}</Option>
            </Select>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="groupVisible = false">{{$LocalH5('buttonCancel')}}</Button>
        <Button type="primary" size="large"  @click="onGroupConfirm" :disabled="!(user || group)">{{$LocalH5('buttonConfirm')}}</Button>
      </div>
    </Modal>
    <emap-flow-pick v-model="visible"  @on-confirm="onConfirm" v-if="!options.groups || emptyUsers"></emap-flow-pick>
  </div>
</template>
<script>
import EmapFlowPick from '../emap-flow-pick.vue'
import { queryCurNodeInfo, queryTurnGroupUsers, queryMultiInstanceGroups } from '@/api/toolbar'

/**
 * 转办分 转办用户组、转办用户两种模式，首先要通过queryCurNodeInfo接口判断, （转办用户组模式废弃）
 * 转办用户又分两种形式，一种是指定用户组的人员，一种是全部人员
 */
export default {
  name: "change-assignee",
  components: {
    EmapFlowPick
  },
  data() {
    return {
      visible: false,
      groupVisible: false,
      emptyUsers: false,
      user: '',
      users: [],
      isMultiInstance: void 0,
      group: [],
      groups: []
    }
  },
  props: {
    value: Boolean,
    options: Object,
    taskid: String,
    defkey: String
  },
  watch: {
    value(val) {
      if(val) {
        this.doVisible()
      }
    },
    groupVisible(val) {
      if(!val) this.$emit('input', false);
    },
    visible(val) {
      if(!val) this.$emit('input', false);
    },
  },
  methods: {
    doVisible() {
      if(this.isMultiInstance) {
        this.groupVisible = true
        this.getMultiInstanceGroup()
      } else {
        if(this.options.groups && !this.emptyUsers && !this.users.length) {
          this.getUsers().then(data => {
            this.users = data || []
            if(this.users.length) {
              this.groupVisible = true
            } else {
              this.emptyUsers = true
              this.visible = true
            }
          })
        } else {
          if(this.users.length) {
            this.groupVisible = true
          } else {
            this.visible = true;
          }
        }
      }
    },
    onGroupConfirm() {
      this.$emit('on-confirm', this.isMultiInstance ? this.group : this.user);
      this.groupVisible = false;
    },
    onConfirm(id) {
      this.$emit('on-confirm', id);
      this.visible = false;
    },
    async getUsers() {
      this.$Spin.show()
      let result = await queryTurnGroupUsers({groups: this.options.groups}).then(data => {
        this.$Spin.hide()
        if(data && data.items) {
          if(data.items.changeAssignees && data.items.changeAssignees.length) {
            this.groupVisible = true
            return data.items.changeAssignees
          } else {
            this.emptyUsers = true
            this.visible = true
          }
        } else {
          console.error("获取转办用户组人员信息失败")
        }
      })
      return result
    },
    getMultiInstanceGroup() {
      queryMultiInstanceGroups({ defKey: this.defkey }).then(data => {
        if(data) {
          this.groups = data.map(item => {
            item.id = "group(" +  item.id + ")"
            return item
          })
        } else {
          console.error("获取用户组信息失败")
        }
      })
    },
    async getCurNodeInfo() {
      let result = await queryCurNodeInfo({taskId: this.taskid}).then(data => {
        if(data && data.currentNodes && data.currentNodes[0]) {
          return data.currentNodes[0].isGroupMultiInstance
        } else {
          console.error("获取当前节点信息失败")
        }
      })

      return result
    }
  }
};
</script>
<style scoped>
  .label {
    width: 100px;
    float: left;
    height: 36px;
    line-height: 36px;
    padding: 0px 16px 0px 2px;
    font-size: 16px;
    text-align: right;
  }
</style>